import { ISubCategoria } from "../../../Interfaces/Geral/SubCategoria/SubCategoriaInterface";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function ListarsSubCategoriasService(
    IDProduto: number,
    IDCategoria: number,
    DSCategoria?: string
) {
    return Service(
        Axios.get<Array<ISubCategoria>>(
            `/home/subcategoria/listarsubcategorias?IDProduto=${IDProduto}&IDCategoria=${IDCategoria}&CategoriaAtendimento=${DSCategoria}`
        )
    );
}
